<template>
  <div>
    <CRow>
      <CCol xs="12" sm="12" md="4" lg="4" xl="3">
        <CCard>
          <CCardHeader class="d-flex justify-content-between">
            <b><i class="fas fa-calendar"></i>&nbsp;Notas de Salida</b>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="12">
                <CSelect label="Almacenes" :options="data_campus" placeholder="--Seleccione una sede --"
                  :value.sync="selectedCampus" @change="onCampusChange" />
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="12" xxl="12">
                <CInput label="Desde" type="date" aria-label="shift_date" @input="onCampusChange" size="sm" id="init"
                  v-model="filter.init" />
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="12" xxl="12">
                <CInput label="Hasta" type="date" aria-label="shift_date" @input="onCampusChange" id="end" size="sm"
                  v-model="filter.end" />
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="12" xxl="12">
                <CInput label="Total de Registros" type="text" size="sm" v-model="totalCompras" disabled />
              </CCol>
              <!-- <CCol xs="12" sm="12" md="12" lg="12" xxl="12">
                <CInput label="Gasto Total de Compras" type="text" size="sm" v-model="sumaTotalCompras" disabled />
              </CCol> -->
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol xs="12" sm="12" md="8" lg="8" xl="9">
        <CTableWrapper :items="data" :fields="fields" hover :striped="true" :border="true" small fixed
          caption="Lista de notas de salida" icon="fas fa-coins" @mtdBack="mtdBack" :size="'md'" :withActions="'2%'"   @mtd_detail_purchase="mtd_detail_purchase">
        </CTableWrapper>
      </CCol>
    </CRow>

  </div>
</template>

<script>
const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "date_formatted", label: "Fecha", _style: "width:5%;" },
  { key: "almacen", label: "Almacen", _style: "width:10%;" },
  { key: "user_name", label: "Usuario", _style: "width:10%;" },
  { key: "detail_note", label: "Productos", _style: "width:10%;" },
  { key: "quantity", label: "Cantidad", _style: "width:10%;" },
  
];

import CTableWrapper from "../../../components/shared/datatable/Table.vue";
import { mapActions } from "vuex";
import moment from "moment";

export default {
  components: {
    CTableWrapper,

  },
  data() {
    return {
      prefix: "exitnote",
      fields,
      data: [],
      data_campus: [],
      totalCompras: 0,
      sumaTotalCompras: 0,
      filter: {
        init: null,
        end: null,
      },
      labelIcon: {
        labelOn: "\u2713",
        labelOff: "\u2715",
      },
      componentKey: 0,
      selectedCampus: null,
      myButtons: [
      //   {
      //     class: "btn-sm",
      //     color: "primary",
      //     tooltip: "Detalle de la compra",
      //     action: "mtd_detail_purchase",
      //     icon: "fas fa-file-pdf",
      //   },
      ],
    };
  },
  computed: {
    cpStatus: function () {
      if (this.companies.state == 1) return true;
      return false;
    },
  },
  created() {
    moment.locale("es");
    this.filter.end = moment().format("YYYY-MM-DD");
    this.filter.init = this.filter.end;
    this.mtd_data();
    this.getCampus();
  },
  methods: {
    ...mapActions(["get", "post"]),
    getCampus() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/stock_transfer/showAlmacenes/" +
          this.$store.getters.get_campu.id,
        token: this.$store.getters.get__token,
      }).then((response) => {
        if (response.statusCode == 200) {
          this.data_campus = [
            { label: "Todos", value: null },
            ...response.data.map((element) => ({
              label: element.name,
              value: element.id,
            })),
          ];
        }
      });
    },
    onCampusChange() {
      if (this.selectedCampus === null) {
        this.mtd_data();
      } else {
        this.mtd_data(this.selectedCampus);
      }
    },
    mtd_data(campuId = null) {
      if (!this.filter.init || !this.filter.end || this.filter.init > this.filter.end) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Por favor, selecciona un rango de fechas válido.',
        });
      }
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/exitnotedetails",
        token: this.$store.getters.get__token,
        params: {
          init: this.filter.init,
          end: this.filter.end,
          campu_id: campuId,
          company_id: this.$store.getters.get_company.id,
        },
      })
        .then((response) => {
          this.clearData();
          this.data = response.data.data;
          this.totalCompras = this.data.length;
          this.sumaTotalCompras = this.data.reduce((sum, item) => sum + parseFloat(item.total || 0), 0).toFixed(2);
          this.data.forEach((item) => {
            item.almacen = item.exitnote.almacen.name;
            item.user_name = item.exitnote.user.name +' '+item.exitnote.user.last_name;
            item.detail_note = item.product_unit.product.name
            item.date_formatted = moment(item.exitnote.date).format("DD/MM/YYYY");
            
          });
          let index = 1;
          this.data.forEach((arr) => {
            arr.index = index;
            index++
          });
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    mtdBack: function () {
      this.$emit("mtdBack");
    },
    clearData() {
      this.data = [];
      this.totalCompras = 0;
      this.sumaTotalCompras = 0;
    },
    mtd_detail_purchase(item) {
      window.open(
        this.$store.getters.get__url + "/purchase/detail-purchase/" + item.id + "/" + this.$store.getters.get__user_id,
        "_blank"
      );
    },
  },

};
</script>

<style lang="scss" scoped></style>